<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="box-header">
        <span class="box-header__title">{{ questionnaire.title }}</span>
        <el-button class="box-header__button" type="text">#{{ cardId }}</el-button>
      </div>
      New+
      <div class="box-card__title">{{ questionnaire.description }}</div>

    </el-card>
  </div>
</template>

<script>
export default {
  name: 'New',
  data () {
    return {
      answers: {},
      answers_item: {},
      loading: false,
      loadForm: false,
      options: {},
      card: '',
      questionnaire: {
        title: null,
        description: null
      },
      error: null,
      cardId: null,
      activeCompendium: {}
    }
  },
  created () {
    this.loadLogic()
  },
  computed: {

  },
  methods: {
    loadLogic () {

    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 960px;
  margin: 0 auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #AAAEBA;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

</style>
